// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"07bf6e46","736":"dd9a3930"}[chunkId] + ".chunk.js";
};